import React, { useRef, useState, useEffect } from 'react';
import styles from './index.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper';
import EcoImg from 'eco-design/base/eco-img';
import { LeftIcon, RightIcon } from '../icons';
import { useLang } from '@/i18n';

const PowerTechnology = () => {
    const { t } = useLang('Delta3MaxSeriesStation.PowerTechnology');
    const swiperRef = useRef<any>(null);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const [slidesOffset, setSlidesOffset] = useState<any>(undefined);

    const contentList = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1757980910897/Rectangle%2050880.jpg',
            title: t('title_1'),
            desc: t('desc_1'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1762329744011/Frame%202094654446%20(1).jpg',
            title: t('title_2'),
            desc: t('desc_2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1757980910703/power322.jpg',
            title: t('title_3'),
            desc: t('desc_3'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1762224301535/Frame%202094654446.jpg',
            title: t('title_4'),
            desc: t('desc_4'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 768) {
                setSlidesOffset(24);
            } else if (window.innerWidth < 1024) {
                setSlidesOffset(48);
            } else if (window.innerWidth < 1340) {
                setSlidesOffset(120);
            } else {
                const offset = (window.innerWidth - 1200) / 2;
                setSlidesOffset(offset);
            }
        }
    }, []);

    return (
        <section className={`${styles.PowerTechnology} GtmModuleData-section`} id="PowerTechnology" data-section-id={'PowerTechnology'}>
            <div className="title-box">
                <h4 className="title">{t('title')}</h4>
                <p className="subtitle">{t('subtitle')}</p>
            </div>
            <div className="content-list">
                <Swiper
                    modules={[Navigation]}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    onSlideChange={(swiper) => {
                        setIsBeginning(swiper.isBeginning);

                        setIsEnd(swiper.isEnd);
                    }}
                    spaceBetween={slidesOffset <= 24 ? 12 : 24}
                    onReachEnd={() => setIsEnd(true)}
                    onFromEdge={() => setIsEnd(false)}
                    slidesPerView={'auto'}
                    centeredSlides={false}
                    slidesPerGroup={1}
                    slidesOffsetBefore={slidesOffset}
                    slidesOffsetAfter={slidesOffset}
                >
                    {contentList.map((item, index) => (
                        <SwiperSlide key={index} className="power-swiper-slide">
                            <div className="item">
                                <div className="item-top">
                                    <EcoImg isOpenLazy className="power-swiper-img" pc={item.pc} />
                                </div>
                                <div className="item-desc-box">
                                    <div className="item-title">{item.title}</div>
                                    <div className="item-desc">{item.desc}</div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className="swiper-btn-box">
                <span className={`btn-item ${isBeginning ? 'disabled' : ''}`} onClick={() => swiperRef.current?.slidePrev()}>
                    <LeftIcon />
                </span>
                <span className={`btn-item ${isEnd ? 'disabled' : ''}`} onClick={() => swiperRef.current?.slideNext()}>
                    <RightIcon />
                </span>
            </div>
        </section>
    );
};

export default PowerTechnology;
